<template>
  <div class="chat-left-sidebar h-full">
    <perfect-scrollbar :options="perfectScrollbarOptions" class="ps-chat-left-sidebar pt-7 pb-3 px-3">
      <h2>
        {{ activeChatRoom ? activeChatRoom.chatroom_key : "" }}
      </h2>
      <template v-if="managedChannels.length">
        <chat-channel-list-item :icon="icons.mdiAccountOutline" :name="$t('Omat keskustelut')"
          :subtitle="$t('Näytä keskustelukanavat')" :selected="selectedChannel == null"
          @click="$emit('my-chats-click')"></chat-channel-list-item>
        <chat-channel-list-item v-for="channel in managedChannels" :key="channel.name"
          :selected="selectedChannel == channel" :icon="icons.mdiCogOutline" :trailingIcon="
            channel.channel_type == 1
              ? icons.mdiAccountOutline
              : icons.mdiAccountGroupOutline
          " :trailingIconTooltip="
            channel.channel_type == 1
              ? $t('Yksityinen kanava')
              : $t('Ryhmäkeskustelu')
          " :name="channel.name" :subtitle="$t('Hallinnoit tätä kanavaa')"
          @click="$emit('managed-channel-click', channel)"></chat-channel-list-item>

        <v-divider></v-divider>
      </template>

      <v-divider></v-divider>

      <v-list v-if="viewManaged && selectedChannel">
        <template v-if="selectedChannel.channel_type === 1">
          <v-list-item v-if="!showSearchBox" class="py-1" dense @click="showSearch">
            <v-list-item-avatar>
              <v-icon>{{ icons.mdiPlus }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="$t('Aloita uusi keskustelu')"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <template v-if="showSearchBox">
            <v-list-item>
              <v-list-item-content>
                <v-text-field v-model="query" outlined hide-details="true" :label="$t('Hae henkilöä')" ref="searchInput"
                  :append-icon="icons.mdiClose" @keyup="findPersons" @click:append="closeSearch"></v-text-field>
              </v-list-item-content>
            </v-list-item>

            <chat-list-item v-for="result in searchResults" :key="`searchresults-${result.id}`" :id="1"
              :name="result.first_name + ' ' + result.last_name" :imageUrl="
                Object.keys(result).length ? result.picture.thumbnail : null
              " :icon="icons.mdiAccountOutline" @click="searchResultClick(result.id)">
            </chat-list-item>
          </template>
        </template>

        <template v-if="!showSearchBox">
          <chat-list-item v-for="room in managedRooms" :key="room.chatroom_key" :name="room.user_name"
            :lastmessage="room.last_message" :boldSubtitle="room.unread" :subtitle="''" :imageUrl="room.picture"
            :selected="
              activeChatRoom && activeChatRoom.roomKey == room.chatroom_key
            " :icon="
              selectedChannel.channel_type === 1
                ? icons.mdiAccountOutline
                : icons.mdiAccountGroupOutline
            " @click="$emit('open-managed-room', room)"></chat-list-item>
        </template>
      </v-list>
      <template v-else>
        <p class="font-weight-medium text-xl primary--text ms-3 mt-4">
          {{ $t("Yksityiset keskustelut") }}
        </p>
        <v-list v-if="privateChannels.length">
          <chat-list-item v-for="channel in privateChannels" :key="channel.id" :name="channel.name"
            :selected="activeChatRoom && activeChatRoom.channelId == channel.id" :subtitle="channel.description"
            :lastmessage="channel.last_message" :boldSubtitle="channel.unread" :imageUrl="channel.image"
            :icon="icons.mdiAccountOutline" @click="$emit('open-channel', channel)"></chat-list-item>
        </v-list>
        <p v-else class="grey--text ms-3 mt-4">{{ $t("Ei kanavia") }}</p>
        <p class="font-weight-medium text-xl primary--text ms-3 mt-4">
          {{ $t("Ryhmäkeskustelut") }}
        </p>
        <v-list v-if="publicChannels.length">
          <chat-list-item v-for="channel in publicChannels" :key="channel.id" :name="channel.name"
            :selected="activeChatRoom && activeChatRoom.channelId == channel.id" :subtitle="channel.description"
            :lastmessage="channel.last_message" :imageUrl="channel.image" :icon="icons.mdiAccountGroupOutline"
            :boldSubtitle="channel.unread" 
            @click="$emit('open-channel', channel)"></chat-list-item>
        </v-list>
        <p v-else class="grey--text ms-3 mt-4">{{ $t("Ei kanavia") }}</p>
      </template>

      <!-- Chats -->

      <!-- <chat-contact
        v-for="contact in filteredChatsContacts"
        :key="`chat-${contact.id}`"
        :user="contact"
        is-chat-contact
        :is-active="activeChatContactId === contact.id"
        :class="{
          'bg-gradient-primary active-chat-contact':
            activeChatContactId === contact.id,
        }"
        @click="$emit('open-chat', contact.id)"
      /> -->

      <!-- Contacts -->

      <!-- <chat-contact
        v-for="contact in filteredContacts"
        :key="contact.id"
        :user="contact"
        @click="$emit('open-chat', contact.id)"
      /> -->
    </perfect-scrollbar>
  </div>
</template>

<script>
import {
  mdiMagnify,
  mdiAccountCogOutline,
  mdiCogOutline,
  mdiPlus,
  mdiClose,
  mdiAccountGroupOutline,
  mdiAccountOutline,
} from "@mdi/js";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import { ref, computed, onMounted, nextTick } from "@vue/composition-api";
// import { avatarText } from "@core/utils/filter";
import ChatContact from "./ChatContact.vue";
// import useChat from "./useChat";
import chatChannelListItem from "./compontents/chatChannelListItem.vue";
import chatListItem from "./compontents/chatListItem.vue";
import api from "@/api";

export default {
  components: {
    chatListItem,
    PerfectScrollbar,
    ChatContact,
    chatChannelListItem,
  },
  props: {
    selectedChannel: {
      type: Object,
      required: false,
    },
    viewManaged: {
      type: Boolean,
      required: false,
    },
    channels: {
      type: Array,
      required: false,
    },
    managedChannels: {
      type: Array,
      required: false,
    },
    managedRooms: {
      type: Array,
      required: false,
    },
    activeChatRoom: {
      type: Object,
      required: false,
    },
  },
  setup(props, context) {
    // const { resolveAvatarBadgeVariant } = useChat();

    // Search Query
    // const searchQuery = ref("");

    // const searchFilterFunction = (contact) =>
    //   contact.fullName.toLowerCase().includes(searchQuery.value.toLowerCase());
    // const filteredChatsContacts = computed(() =>
    //   props.chatsContacts.filter(searchFilterFunction)
    // );
    // const filteredContacts = computed(() =>
    //   props.contacts.filter(searchFilterFunction)
    // );

    // Perfect scrollbar options
    const perfectScrollbarOptions = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
      wheelSpeed: 0.7,
    };

    const showSearchBox = ref(false);
    const query = ref("");
    const searchResults = ref([]);
    let searchTimeout = null;
    const searchInput = ref(null);

    const privateChannels = computed(() => {
      return props.channels.filter(
        (c) =>
          c.channel_type == 1 &&
          !props.managedChannels.find((mc) => mc.id == c.id)
      );
    });

    const publicChannels = computed(() => {
      return props.channels.filter(
        (c) =>
          c.channel_type == 2 &&
          !props.managedChannels.find((mc) => mc.id == c.id)
      );
    });

    const showSearch = () => {
      showSearchBox.value = true;
      query.value = "";
      nextTick(() => {
        searchInput.value.focus();
      });
    };

    const closeSearch = () => {
      showSearchBox.value = false;
    };

    const searchResultClick = (userId) => {
      context.emit("on-search-result-click", userId);
      showSearchBox.value = false;
      query.value = "";
    };

    const findPersons = async (e) => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        if (e.target.value.length > 2) {
          searchPersons();
        }
      }, 400);
    };

    const searchPersons = async () => {
      const response = await api.searchPersons(query.value);
      if (response.ok) {
        searchResults.value = response.data.results;
      }
    };

    return {
      privateChannels,
      publicChannels,
      showSearch,
      closeSearch,
      showSearchBox,
      findPersons,
      searchResults,
      searchInput,
      query,
      searchResultClick,

      // Use Chat
      // resolveAvatarBadgeVariant,

      // Search
      // searchQuery,
      // filteredChatsContacts,
      // filteredContacts,

      // Perfect Scrollbar options
      perfectScrollbarOptions,

      // Filter
      // avatarText,

      // Icons
      icons: {
        mdiMagnify,
        mdiClose,
        mdiAccountOutline,
        mdiAccountCogOutline,
        mdiPlus,
        mdiClose,
        mdiAccountGroupOutline,
        mdiCogOutline,
      },
    };
  },
};
</script>
